import NewsCategory from './NewsCategory.jsx';
import NewsDetail from './NewsDetail.jsx';

export {
  NewsCategory,
  NewsDetail
}


// WEBPACK FOOTER //
// ./components/news/index.js